module.exports = __webpack_public_path__ + "fonts/montserrat-latin-300italic.56f34ea.woff2";